import React from "react";
import { Spinner } from "react-bootstrap";
import { describeLookupMatch } from "./supplierManagementHelpers";

const LOOKUP_TONES = {
  info: { bg: "#eff6ff", border: "#bfdbfe", color: "#1d4ed8" },
  warn: { bg: "#fef3c7", border: "#fde68a", color: "#92400e" },
  block: { bg: "#fee2e2", border: "#fecaca", color: "#b91c1c" },
};

const SupplierLookupBanner = ({ state }) => {
  if (state?.loading) {
    return (
      <div
        style={{
          background: LOOKUP_TONES.info.bg,
          border: `1px solid ${LOOKUP_TONES.info.border}`,
          borderRadius: 10,
          padding: "10px 12px",
          color: LOOKUP_TONES.info.color,
          fontSize: 12,
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <Spinner animation="border" size="sm" />
        <span>Checking existing suppliers…</span>
      </div>
    );
  }
  const message = describeLookupMatch(state?.match);
  if (!message) return null;
  const tone = LOOKUP_TONES[message.tone];
  return (
    <div
      style={{
        background: tone.bg,
        border: `1px solid ${tone.border}`,
        borderRadius: 10,
        padding: "10px 12px",
        color: tone.color,
      }}
    >
      <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 2 }}>
        {message.title}
      </div>
      <div style={{ fontSize: 12, fontWeight: 500, opacity: 0.9 }}>
        {message.body}
      </div>
    </div>
  );
};

export default SupplierLookupBanner;
